App.ratingCallback = (rating) ->
  $('.stars>a').each (e) ->
  if $('#user-star-rating').length && !$('#review').length && \
  ($('a[data-rating="1"]').css('color') == "rgb(224, 224, 224)" || \
  $('a[data-rating="1"]').css('color') == "rgb(255, 114, 0)" )
    $.ajax({
      url: '/rating-review/' + $('body').data('page-id') + '/' + rating
      success: (data) ->
        loadInLightbox({
          url: '/write-review/' + $('body').data('page-id')
          style: 'max-width: 45em'
          centered: true
          onLoad: ->
            $('#book-rating-review').rating(false)
        })
    })
  else
    $.ajax({
      url: '/rating-review/' + $('body').data('page-id') + '/' + rating
    })
  return

$ ->
  $.fn.rating = (callback) ->
    # each for all item
    @each (i, v) ->
      $(v).data('rating-callback', callback)
      $(v).on('init.rating', $.fn.rating.init)\
      .on('set.rating', $.fn.rating.set).on('hover.rating', $.fn.rating.hover).trigger 'init.rating'
      return
    return

  $.extend $.fn.rating, {
    init: (e) ->
      el = $(this)
      list = ''
      isChecked = el.attr('data-rating')
      if el.has("input").length == 0
        i = 0
        l = 5
        while i < l
          list = list + '<svg class="ico" data-rating="' + (i + 1) + \
          '"><use href="/icons.svg#ico-star"/></svg>'
          i++
        el.append('<input type="hidden" name="' + el.attr('id') + '" value="' + isChecked + \
        '"><div class="stars">' + list + '</div>').trigger 'set.rating', isChecked
      if el.hasClass('init')
        $('a', el).on 'click', $.fn.rating.click
        el.trigger 'hover.rating'
        el.removeClass('init')
    set: (e, val) ->
      el = $(this)
      item = $('a', el)
      input = undefined
      if val
        svg = $('svg', item)
        svg.svgSet('ico-star-empty')
        input = item.filter((i) ->
          if $(this).attr('data-rating') == val
            $ this
          else
            false
        )
        input.svgSet('ico-star').prevAll().svgSet('ico-star')
        input.css("color", "#ffc600").prevAll().css("color", "#ffc600")
      return
    hover: (e) ->
      el = $(this)
      stars = $('a', el)
      stars.on 'mouseenter', (e) ->
        # add tmp class when mouse enter
        $(this).addClass('tmp_fs').prevAll().addClass 'tmp_fs'
        $(this).nextAll().addClass 'tmp_es'
        return
      stars.on 'mouseleave', (e) ->
        # remove all tmp class when mouse leave
        $(this).removeClass('tmp_fs').prevAll().removeClass 'tmp_fs'
        $(this).nextAll().removeClass 'tmp_es'
        return
      return
    click: (e) ->
      e.preventDefault()
      el = $(e.target).closest('a')
      if $('#user-star-rating').length && !$('#review').length && \
      $('a[data-rating="1"]').css('color') == "rgb(255, 198, 0)"
        $.ajax({
          url: '/remove-rating/' + $('body').data('page-id')
          success: ->
            el.svgSet('ico-star').css("color", "#E0E0E0").\
            prevAll().svgSet('ico-star').css("color", "#E0E0E0").\
            nextAll().svgSet('ico-star').css("color", "#E0E0E0")
          })
        return
      el.css("color", "#ffc600").prevAll().css("color", "#ffc600").nextAll().css('color', '#ffc600')
      el.nextAll().svgSet('ico-star-empty')
      container = el.closest('.stars').parent()
      input = container.children('input')
      rate = el.attr('data-rating')
      input.val(rate)
      container.trigger('set.rating', rate)
      if container.data('rating-callback')
        App.ratingCallback(rate)
      return
  }
  $('.star-rating').rating(true)
  $('body').on 'click', '#saveReview' , ->
    console.log('saveReview')
    $.post '/write-review' , {
      ean: $('body').data('page-id')
      review: $('#review').val().trim()
      name: $('#post_anon').attr('checked')
    }, (json) ->
      if json.success
        console.log('success')
        $('.review-error-message').addClass('hidden')
        window.location.href = window.location.href.replace('#review', '')
      else
        console.log('errors')
        $('.review-error-message').text(json.message)
        $('.review-error-message').removeClass('hidden')
      return
    return
  if $('#review').length || $('#user-star-rating').length
    if $('#user-star-rating').length && !$('#review').length && \
    ($('a[data-rating="1"]').css('color') == "rgb(224, 224, 224)" || \
    $('a[data-rating="1"]').css('color') == "rgb(255, 114, 0)" )
      $('#new-rating').removeClass('hidden')
      $('#rating-exists').addClass('hidden')
    else
      $('#rating-exists').removeClass('hidden')
      $('#new-rating').addClass('hidden')
    $('#book-rating').on 'click', ->
      if $('#new-rating').hasClass('hidden')
        $('#new-rating').removeClass('hidden')
        $('#rating-exists').addClass('hidden')
      else
        $('#new-rating').addClass('hidden')
        $('#rating-exists').removeClass('hidden')